import React from 'react'
import { Tab, Tabs } from '@material-ui/core'
import BasePage from '../../../pages/basePage'
import { motion } from "framer-motion";

import Content from './Content'
import { PackgeProvider } from '../../../hooks/EditPackageContext'
import { useMenu } from '../../../store/global/useMenu';
import { Package } from 'lucide-react';

function EditPackage() {
  const menuSize = useMenu(st => st.data.size)

  return (
    <BasePage pageTitle={<><Package className='w-6 h-6' />Editar Pacote</>}>
      <motion.div
        initial={{ width: `calc(100vw - 2rem - ${menuSize})` }}
        animate={{ width: `calc(100vw - 2rem - ${menuSize})` }}
        transition={{ duration: 0.3 }}
        className='flex flex-col pl-2 pr-4'>
        <Tabs
          value="0"
          indicatorColor="primary"
          textColor="primary"
          aria-label="disabled tabs example"
        >
          <Tab label="DADOS GERAIS" value="0" />
        </Tabs>
        <PackgeProvider>
          <Content />
        </PackgeProvider>
      </motion.div>
    </BasePage>
  )
}

export default EditPackage
